import PropTypes from "prop-types"
import { Gradient } from "@mui/icons-material"
import EditTopic from "components/edit-topic"
import { PERMISSION_LEVEL } from "helpers/shapes"
import Resource from "../resource"
import { ButtonAction } from "../card-actions"
import { renderAction } from "../../helpers"
import saveRecentResources from "hocs/saveRecentResources"
import { getTopicMenuItems } from "modules/research-topic-root/selectors/menu"

export default function Topic({ handlers, resource, permissionLevel, openDialog, models, trackResourceEvent, toggleFavorite, account, model, isOpPro, dispatch }) {
  const openEditDialog = () => {
    const EditTopicWithRecentResources = saveRecentResources(EditTopic, "topic.id")
    openDialog({
      content: <EditTopicWithRecentResources
        topic={resource}
        models={models}
        modelId={model}
        saveTopic={handlers.updateTopic}
      />,
    })
  }

  const trackActionClick = (type, action) => {
    return () => {
      trackResourceEvent({
        trackType: "resources-secondary-link",
        trackPayload: {
          actionType: type,
          resourceType: "topic",
        },
      })
      if (action) action()
    }
  }

  const computeAction = () => {
    const { description } = resource

    // getCardAction displays only the first valid button
    return renderAction([{
      condition: !description,
      render: <ButtonAction onClick={trackActionClick("description", openEditDialog)}>Add description</ButtonAction>,
    }])
  }
  return <Resource {...{
    url: `/${account}/t/${resource.id}/experiments`,
    account,
    trackResourceEvent,
    toggleFavorite,
    resource,
    resourceType: "topic",
    resourceIcon: <Gradient />,
    permissionLevel,
    action: computeAction(),
    menuItems: getTopicMenuItems(account, resource),
    models,
    isOpPro,
    dispatch,
  }}
  />
}

Topic.propTypes = {
  handlers: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  permissionLevel: PERMISSION_LEVEL.isRequired,
  openDialog: PropTypes.func.isRequired,
  models: PropTypes.object.isRequired,
  trackResourceEvent: PropTypes.func.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  model: PropTypes.string,
  isOpPro: PropTypes.bool.isRequired,
  dispatch: PropTypes.func,
}
